import React from 'react';
import IconLoadingError from './media/IconLoadingError';
import * as Styles from './LoadingError.styles';
import { Button } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';
import useLocale from '@/hooks/useLocale';

const LoadingError = ({ getHomeRequest }) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 600;
  const { home: homeLocale } = useLocale();

  const reloadPage = () => {
    getHomeRequest && getHomeRequest();
  };

  return (
    <Styles.WrapperLoadingError data-testid="wrapper-loading-error">
      <IconLoadingError iconWidth={mobile ? '32' : '48'} iconHeight={mobile ? '32' : '48'} />
      <Styles.Message>
        {homeLocale.infosLoadingError.message}
      </Styles.Message>
      <Button
        version="v2"
        size="large"
        label={homeLocale.infosLoadingError.buttonLabel}
        onClick={reloadPage}
        data-testid="reload-button"
      />
    </Styles.WrapperLoadingError>
  );
};

export default LoadingError;
